import { GetterTree } from 'vuex'
import { Auth } from './types'
import { RootState } from '../types'

export const getters: GetterTree<Auth, RootState> = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  tokenValid: state => state.tokenValid,
  user: state => state.user,
  avatar: state => state.user.photo,
  wsConnectionActive: state => state.wsConnectionActive,
  connection: state => state.connection,
  session: state => state.session,
  termsConditionsBlocker: state => state.termsConditionsBlocker,
  userIsAdmin: state => state.userIsAdmin,
  accountData: state => state.accountData,
  businessAccountId: state => state.accountData.meta.business_account_id,
  accountInformation: state => state.accountInformation,
  getAccountVersionAccepted: state => state.accountVersionAccepted,
  getLatestVersionTermsConditions: state => state.latestVersionTermsConditions
}
